import { Injectable, Signal } from '@angular/core';
import { IIssueData, IIssueModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IssueActions } from '../store/issue.actions';
import { IssueSelectors } from '../store/issue.selectors';
import { IIssueState } from '../store/issue.state';

@Injectable({
  providedIn: 'root'
})
export class IssueStore extends StateAccessService<IIssueState> {
  readonly state$: Observable<IIssueState>;

  readonly data$$: Signal<IIssueData>;
  readonly model$$: Signal<IIssueModel>;
  readonly screenName$$: Signal<string>;

  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(IssueSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(IssueSelectors.data);
    this.screenName$$ = this.stateFacade.selectSignal$(IssueSelectors.screenName);
  }

  dispatchIssueReset() {
    this.stateFacade.dispatch(IssueActions.reset());
  }
  dispatchIssueLoad() {
    this.stateFacade.dispatch(IssueActions.load());
  }
  dispatchIssueLoadSuccess({ model, data }: { model: IIssueModel; data: IIssueData }) {
    this.stateFacade.dispatch(IssueActions.loadSuccess({ model, data }));
  }
  dispatchIssueSubmit() {
    this.stateFacade.dispatch(IssueActions.submit());
  }
  dispatchIssueSubmitSuccess({ model, data }: { model: IIssueModel; data: IIssueData }) {
    this.stateFacade.dispatch(IssueActions.submitSuccess({ model, data }));
  }
  dispatchSaveScreenName({ screenName }: { screenName: string }) {
    this.stateFacade.dispatch(IssueActions.saveScreenName({ screenName }));
  }
}
